import React from 'react'
import PropTypes from 'prop-types'
// REDUX BITS
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createFilter } from 'react-search-input'
import * as commonActions from '../../actions/commonActions'
import * as familyActions from '../../actions/familyActions'
import * as authActions from '../../actions/authActions'
import * as communitiesActions from '../../actions/communitiesActions'
import * as invitationActions from '../../actions/invitationActions'
import * as fadeAnimation from '../common/fadeAnimation'
import ValidationModal from '../common/ValidationModal'
import ConfirmationModal from '../common/ConfirmationModal'
import { checkLicensePermission } from '../../utility/communityLicense'

// DEPENDENCIES
import _ from 'lodash'
import Modal from 'react-modal'
import Loader from '../common/loader/legacy-loaders/Op36Loader'

import { isValidEmail } from '../../utility/helperFunctions'

// CHILDREN
import FamilyEditForm from './family_modals/FamilyEditForm.js'
import Placeholder from '../common/Placeholder'
import FamilyCard from '../common/FamilyCard'
import InvitationCard from '../common/InvitationCard'
import { withRouting } from '../common/hooks'
import SearchInput from '../common/SearchInput'
import './Families.scss'

// const modalStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)"
//   }
// };

const KEYS_TO_FILTERS = ['name', 'email']

class FamiliesPage extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      community_id: '',
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
      type: 'Student',
      family_admin: 'true',
      showAddFamilyModal: false,
      alertTitle: 'Error',
      alertMessage: 'Something went wrong, please try again later.',
      alertType: 'danger',
      in: false,
      loading: false,
      errorTitle: 'Error',
      errorMessage: 'Something went wrong. Please try again later.',
      addFamily: true,
      familyLoader: true,
      addFamilyLoader: false,
      showValidationModal: false,
      validationSuccess: true,
      validationMessage: '',
      searchTerm: '',
      confirmationMessage: '',
      confirmationType: '',
      showConfirmationModal: false,
      invitation: {},
      actionLoader: false,
    }

    this.openInviteFamilyModal = this.openInviteFamilyModal.bind(this)
    this.openAddFamilyModal = this.openAddFamilyModal.bind(this)
    this.closeAddFamilyModal = this.closeAddFamilyModal.bind(this)
    this.onRegisterSubmit = this.onRegisterSubmit.bind(this)

    this.licenseType = this.props.user?.communities[0]?.license_type

    this.alertDialog = React.createRef()
  }

  componentDidMount() {
    const {
      common_actions,
      communities_actions,
      family_actions,
      user,
    } = this.props
    common_actions.showSideBar(true)
    common_actions.showNavBar(true)
    // communities_actions.getCommunities();
    family_actions.getFamilies(user.communities[0].id).then(() => {
      communities_actions
        .getCommunityInvitations(user.communities[0].id)
        .then((_res) => {
          this.setState({
            familyLoader: false,
          })
        })
    })

    if (user.communities) {
      this.setState({ community_id: user.communities[0].id })
    }

    this.applySmartToggle()
  }

  applySmartToggle(){
    const { location } = this.props
    if (!_.isEmpty(location.state) && location.state.smartToggle) {
      // reset the location state to prevent inifinte rerender of this component
      this.props.navigate(location.pathname, {})
      this.props.navigate('/students-families/invite-families')
    }
  }

  searchUpdated = (e) => {
    this.setState({ searchTerm: e.target.value })
  }

  //
  // MODAL ACTIONS
  //

  openConfirmationModal = (
    confirmationMessage,
    invitation,
    confirmationType
  ) => {
    this.setState({
      showConfirmationModal: true,
      invitation,
      confirmationMessage,
      confirmationType,
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      showConfirmationModal: false,
      invitation: {},
      confirmationMessage: '',
      confirmationType: '',
    })
  }

  openInviteFamilyModal() {
    this.props.navigate('/students-families/invite-families')
    this.setState({
      first_name: '',
      last_name: '',
      email: '',
    })
  }

  openAddFamilyModal() {
    this.setState({
      showAddFamilyModal: true,
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
    })
  }

  closeAddFamilyModal() {
    this.setState({
      showAddFamilyModal: false,
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_confirmation: '',
    })
  }

  closeValidationModal = () => {
    this.setState({
      showValidationModal: false,
    })
  }

  //
  // FORM FUNCTIONS
  //

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  //
  // MODAL FUNCTIONS
  //

  validateForm(formState) {
    return (
      formState.first_name &&
      formState.last_name &&
      formState.password &&
      formState.password_confirmation &&
      formState.email
    )
  }

  deleteInvitation = () => {
    const { invitation } = this.state
    const { invitation_actions } = this.props
    this.setState({ actionLoader: true })
    invitation_actions.deleteInvitation(invitation).then(() => {
      this.closeConfirmationModal()
      this.setState({
        showValidationModal: true,
        validationMessage: 'You have successfully deleted the invitation',
        validationSuccess: true,
        actionLoader: false,
      })
    })
  }

  sendReminder = () => {
    const { user, family_actions } = this.props
    const invitation = this.state.invitation

    const url = window.location.origin

    this.setState(
      {
        actionLoader: true,
      },
      () => {
        family_actions
          .sendFamilyReminder(invitation, user.communities[0].id, user.id, url)
          .then(() => {
            this.closeConfirmationModal()
            this.setState({
              showValidationModal: true,
              validationMessage: `You have successfully reminded the ${
                invitation.first_name || ''
              } ${invitation.last_name || ''} family`,
              validationSuccess: true,
              actionLoader: false,
            })
          })
      }
    )
  }

  onRegisterSubmit(formState) {
    const newFamilyMember = { ...formState }
    this.setState({ loading: true, addFamilyLoader: true })
    // WIP here
    if (this.validateForm(formState)) {
      if (formState.password === formState.password_confirmation) {
        newFamilyMember.community_id = this.props.user.communities[0].id
        this.props.auth_actions.createFamilyUser(newFamilyMember, () => {
          this.setState({ loading: false, addFamilyLoader: false })
          this.setState({
            showValidationModal: true,
            validationSuccess: true,
            validationMessage: 'Family has been added to the community!',
          })
          this.props.family_actions.getFamilies(
            this.props.user.communities[0].id
          )
          this.closeAddFamilyModal()
        })
        //   .then(response => {
        // this.setState({ loading: false, addFamilyLoader: false });
        // this.setState({
        //   showValidationModal: true,
        //   validationSuccess: true,
        //   validationMessage: "Family has been added to the community!"
        // });
        // this.props.family_actions.getFamilies(
        //   this.props.user.communities[0].id
        // );
        // this.closeAddFamilyModal();
        //   })
        // // .catch(_err => {
        //   this.setState({ loading: false, addFamilyLoader: false });
        // });
      } else {
        this.setState({
          showValidationModal: true,
          validationSuccess: false,
          validationMessage: 'Passwords do not match',
        })
        this.setState({ loading: false, addFamilyLoader: false })
      }
    } else {
      this.setState({
        showValidationModal: true,
        validationSuccess: false,
        validationMessage:
          'Please fill out all of the fields before registering',
      })
      this.setState({ loading: false, addFamilyLoader: false })
    }
  }

  getWindowURl() {
    //window.location.origin
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      return 'http://localhost:3001' // LOCAL
    } else {
      //baseURL = 'https://operation36-dev.herokuapp.com'; // DEV
      return 'https://operation36golf.com' // PROD
    }
  }

  validateInviteForm = () => {
    const { email, first_name, last_name } = this.state

    if (email && first_name && last_name && isValidEmail(email)) {
      return false
    }
    return true
  }

  displayAddFamilyModal() {
    return (
      <Modal
        isOpen={this.state.showAddFamilyModal}
        onRequestClose={this.closeAddFamilyModal}
        contentLabel='Add Family Modal'
      >
        <div className='modal-header row'>
          <div className='col-11'>
            <h5 className='modal-title display-4'>
              Add Family To Your Community
            </h5>
          </div>
          <div className='col-1'>
            <button
              type='button'
              className='close pull-right font-200'
              data-dismiss='modal'
              aria-label='Close'
              onClick={this.closeAddFamilyModal}
            >
              <span aria-hidden='true'>✕</span>
            </button>
          </div>
        </div>
        <div className='modal-content'>
          <div className='row my-3'>
            <div className='col'>
              <h2 className='text-center'>
                Add a family and send their login credentials
              </h2>
            </div>
          </div>
          <FamilyEditForm
            update={false}
            showAlert={this.showAlert}
            loader={this.state.addFamilyLoader}
            addFamily={this.onRegisterSubmit}
            handleInputChange={this.handleInputChange}
          />
        </div>
      </Modal>
    )
  }

  toggleEnterState = () => {
    setTimeout(
      () => {
        this.setState({ in: true })
      },
      fadeAnimation.FADE_DURATION
    )
  }

  renderFamilies = () => {
    const { families } = this.props
    const filteredFamilies = families.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    )

    return filteredFamilies.map((family) => {
      if (family.users.length > 0) {
        return <FamilyCard family={family} key={family.id} />
      }
      return null
    })
  }

  renderInvitations = () => {
    const { invitations } = this.props
    if (invitations && invitations.length > 0) {
      return invitations.map((invitation) => (
        <InvitationCard
          invitation={invitation}
          toggleConfirmation={this.openConfirmationModal}
          key={invitation.id}
        />
      ))
    }
    return (
      <Placeholder
        title={'No Invitations Listed'}
        icon={'fa-envelope'}
        subtext1={'You currently have no pending invitations.'}
        subtext2={'Click the invite family button below'}
        subtext3={'to send an invite'}
        buttonText={'Invite Family'}
        buttonIcon={'fa-envelope'}
        handleClick={this.openInviteFamilyModal}
      />
    )
  }

  renderFamilyView = () => {
    if (this.props.families.length > 0) {
      return (
        <div className='animated fadeIn'>
          <div className='families-search-bar mt-2'>
            <SearchInput placeholder='Search Families' onChange={this.searchUpdated}/>
          </div>
          <div className='row'>
            <div className='col'>
              {/* <h4 className="families-title">Active Families</h4> */}
              <div className='row'>{this.renderFamilies()}</div>
            </div>
            {checkLicensePermission(this.licenseType, ['standard_legacy']) &&
              <div className='col-md-3 border-left'>
                <h4 className='families-title'>Invitations</h4>
                <div className='invitations-container'>
                  {this.renderInvitations()}
                </div>
              </div>
            }
          </div>
          {/* <FamiliesTable families={families} /> */}
        </div>
      )
    } else {
      return (
        <Placeholder
          title={'No Families Yet...'}
          icon={'fa-users'}
          subtext1={'You currently do not have families listed'}
          subtext2={'Add or Invite a Family to get started'}
        />
      )
    }
  }

  render() {
    const {
      familyLoader,
      validationMessage,
      validationSuccess,
      showValidationModal,
      showConfirmationModal,
      confirmationMessage,
      confirmationType,
      actionLoader,
    } = this.state
    return (
      <div id='FamiliesPage' className='animated fadeIn'>
        <div>
          {familyLoader ? (
            <div className='' style={{ marginTop: '50px', width: '100%' }}>
              <Loader message='loading families' />
            </div>
          ) : (
            this.renderFamilyView()
          )}

          {this.displayAddFamilyModal()}
          <ValidationModal
            validationSuccess={validationSuccess}
            showValidationModal={showValidationModal}
            closeValidationModal={this.closeValidationModal}
            validationMessage={validationMessage}
          />
          <ConfirmationModal
            showConfirmationModal={showConfirmationModal}
            closeConfirmationModal={this.closeConfirmationModal}
            confirmationMessage={confirmationMessage}
            confirmationDenied={this.closeConfirmationModal}
            confirmationProceed={
              confirmationType === 'delete'
                ? this.deleteInvitation
                : this.sendReminder
            }
            actionLoader={actionLoader}
          />
        </div>
      </div>
    )
  }
}

FamiliesPage.propTypes = {
  navigate: PropTypes.func,
  location: PropTypes.object,
  families: PropTypes.array,
  invitations: PropTypes.array,
  user: PropTypes.shape({
    id: PropTypes.number,
    communities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      license_type: PropTypes.string,
    })),
  }),
  family_actions: PropTypes.shape({
    getFamilies: PropTypes.func,
    sendFamilyReminder: PropTypes.func,
  }),
  auth_actions: PropTypes.shape({
    createFamilyUser: PropTypes.func,
  }),
  invitation_actions: PropTypes.shape({
    deleteInvitation: PropTypes.func,
  }),
  communities_actions: PropTypes.shape({
    getCommunityInvitations: PropTypes.func,
  }),
  common_actions: PropTypes.shape({
    showSideBar: PropTypes.func,
    showNavBar: PropTypes.func,
  }),
}


function mapStateToProps(state, _ownProps) {
  return {
    ui: state.ui,
    user: state.user.current_user,
    families: state.families,
    communities: state.communities.communities,
    invitations: state.invitations,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    common_actions: bindActionCreators(commonActions, dispatch),
    family_actions: bindActionCreators(familyActions, dispatch),
    auth_actions: bindActionCreators(authActions, dispatch),
    communities_actions: bindActionCreators(communitiesActions, dispatch),
    invitation_actions: bindActionCreators(invitationActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouting(FamiliesPage))
